import { MatPaginatorIntl } from '@angular/material/paginator';

const italianRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 su ${length}`; }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
    Math.min(startIndex + pageSize, length) :
    startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} su ${length}`;
}


export function getItalianPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Oggetti per pagina:';
  paginatorIntl.nextPageLabel = 'Prossima pagina';
  paginatorIntl.previousPageLabel = 'Pagina Scorsa';
  paginatorIntl.getRangeLabel = italianRangeLabel;

  return paginatorIntl;
}
